import { SectionBreak, Button, H2, FormGroup, ErrorText, LabelText } from "govuk-react";
import React, { memo } from "react";
import { useForm } from "../hooks/formContext";
import { PrePpWlEnquiryStages } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";
import { GovField } from "@publicMirage/components/govReact/GovField";
import { PrePpWlFormComponentStepProps } from "../PrePublicPortalWlForm";
import Box from "@mui/material/Box";

export const PrePpWlStageStep = memo((props: PrePpWlFormComponentStepProps) => {
    const { next } = props;
    const { toFieldProps, getFieldProp, previous } = useForm();
    const errorMsg = getFieldProp("enquiryStage", "errorMsg");
    return (
        <>
            <H2>Stage</H2>
            <SectionBreak level="LARGE" visible />
            <FormGroup error={!!errorMsg}>
                <LabelText className="required">Select stage of your enquiry</LabelText>
                <ErrorText>{errorMsg}</ErrorText>
                <GovField {...toFieldProps("enquiryStage", "RADIO", PrePpWlEnquiryStages.PRINCIPLE)} label="Stage 1 (Principle)" />
                <GovField {...toFieldProps("enquiryStage", "RADIO", PrePpWlEnquiryStages.DETAILED_DESIGN_AND_LAYOUT)} label="Stage 2 (Detailed Design And Layout)" />
            </FormGroup>

            <Box display="flex" justifyContent="space-between">
                <Button onClick={previous}>Previous</Button>
                <Button onClick={next}>Next</Button>
            </Box>
        </>
    );
});
